import React from 'react';
import { View, StyleSheet, Image, Dimensions, Platform } from 'react-native';
import CustomText from '../customText/CustomText';
import theme from '../../constants/theme.style.js';

const waves = require('../../assets/waves.png');

const { height } = Dimensions.get('window');
const { width } = Dimensions.get('window');

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    height: height / 5,
    position: 'relative',
    marginLeft: width < 900 ? theme.CONTAINER_MARGIN * 2 : 0,
  },
  waveTop: {
    position: 'absolute',
    left: -50,
    bottom: 40,
    height: 150,
    width: '80%',
    maxWidth: 500,
  },
  headerTextContainer: {
    flex: 1,
    justifyContent: 'flex-end',
    marginBottom: theme.CONTAINER_MARGIN * 1,
  },
  headerText: {
    color: theme.WHITE_COLOR,
    fontSize: theme.FONT_SIZE_HEADLINE * 1.5,
    fontFamily: 'Pacifico',
  },
  headerTextName: {
    color: theme.GREEN_LIGHT_COLOR,
  },
});

export default function HomeHeader(props) {
  const { firstname } = props;

  const profileName = firstname;
  const myDate = new Date();
  const hrs = myDate.getHours();

  let greet;

  if (hrs < 12) greet = 'Good Morning,';
  else if (hrs >= 12 && hrs <= 17) greet = 'Lovely Afternoon,';
  else if (hrs >= 17 && hrs <= 24) greet = 'Good Evening,';

  let wave;
  if (Platform.OS === ('ios' || 'android')) {
    wave = <Image style={styles.waveTop} source={waves} resizeMode="contain" />;
  }

  return (
    <View style={styles.header}>
      {wave}
      <View style={styles.headerTextContainer}>
        <CustomText style={styles.headerText} testID="greet">
          {greet}
        </CustomText>
        <CustomText style={[styles.headerText, styles.headerTextName]} testID="firstname">
          {profileName}
        </CustomText>
      </View>
    </View>
  );
}
